module.exports = __webpack_public_path__ + "img/ic_bolt_purple.4f848d4a.svg";